<template>
  <span class="float-end">
    <i
      v-if="sortColumn !== column"
      class="fa-solid fa-sort text-muted ms-1 sort-icon-inactive"
    ></i>
    <i
      v-else
      :class="`fa-solid ${sortDirection === 'asc' ? 'fa-sort-up' : 'fa-sort-down'} ms-1`"
    ></i>
  </span>
</template>

<script setup lang="ts">
type SortDirection = 'asc' | 'desc';

defineProps<{
  column: string;
  sortColumn: string | null;
  sortDirection: SortDirection;
}>();
</script>

<style>
  .sortable-col {
    cursor: pointer;
    user-select: none;
    white-space: nowrap;
  }

  .sortable-col:hover {
    background-color: var(--bs-table-hover-bg);
  }

  .sortable-col.sort-active {
    font-weight: 600;
  }

  .sortable-col .sort-icon-inactive {
    opacity: 0.35;
  }
</style>
